/**
 * RESPONSIBILITY: draw a block of a picture beside words, on whichever side it is told.
 *
 * One component for both templates: they differ by which side the picture is on, and two
 * files that differ by that are a place for the pair to drift apart. With only one of the
 * two filled in, it takes the full width rather than leaving half the row empty.
 */
import { Html } from '@framework/react';
import { hasImage } from '@framework/core';
import { ADC_THEME } from '@app/sections';
import { AdcBand } from './AdcBand';
import { Picture } from '../commons/Picture';
import type { AdcBlockProps } from './kind';

export function AdcSplit({ b, imageFirst }: AdcBlockProps & { imageFirst: boolean }) {
  const pic = hasImage(b.image);
  if (!pic && !b.bodyHtml) return null;

  const both = pic && b.bodyHtml;
  return (
    <AdcBand theme={imageFirst ? ADC_THEME.ImageLeft : ADC_THEME.ImageRight} heading={b.heading}>
      <div className={`adc-split${imageFirst ? '' : ' is-flipped'}${both ? '' : ' is-solo'}`}>
        {pic ? <Picture value={b.image} className="adc-pic" /> : null}
        {b.bodyHtml ? <Html className="md-body adc-copy">{b.bodyHtml}</Html> : null}
      </div>
    </AdcBand>
  );
}

export const AdcImageLeft = (p: AdcBlockProps) => <AdcSplit {...p} imageFirst />;
export const AdcImageRight = (p: AdcBlockProps) => <AdcSplit {...p} imageFirst={false} />;
